import { useHistory, useParams } from "react-router-dom";
import { common_utils } from "../../../../../../common/common_utils";
import { AppTimeFinder } from "../../../../time-finder/components/time_finder";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { useCurrentGuildData } from "../hooks/use_guild_data";
import { useRoles } from "../hooks/use_roles";

export function TimeFinderCreate() {
	const { server_id } = useParams<{ server_id: string }>();

	const history = useHistory();

	const mutation = trpc.time_finder.create.useMutation({
		onSuccess: (data) => {
			history.push(
				common_utils.getTimeFinderURL({
					server_id,
					type: "view",
					instance_id: data.time_finder_instance_id,
					just_created_view: true,
				})
			);
		},
	});

	const guild = useCurrentGuildData();
	const roles = useRoles();

	const does_have_permission_query =
		trpc.members.doesUserHavePermission.useQuery(
			{
				guild_id: server_id,
				permission: "create",
			},
			{
				onSuccess: (val) => {},
			}
		);

	if (
		does_have_permission_query.isSuccess &&
		!does_have_permission_query.data
	) {
		return (
			<div className="flex w-full  flex-col items-center">
				<DashboardUtils.RenderErrorContent
					text="You must have 'create' permissions in order to create a time finder."
					title="Invalid Permissions"
				/>
			</div>
		);
	}

	return (
		<AppTimeFinder
			onSubmit={(opts) => {
				console.log(server_id);
				mutation.mutate({ ...opts, guild_id: server_id });
			}}
			is_loading={
				mutation.isLoading ||
				mutation.isSuccess ||
				!does_have_permission_query.isSuccess
			}
			is_public={false}
			is_edit={false}
			is_on_dashboard={true}
			does_have_premium={guild?.is_premium}
			roles={roles}
		/>
	);
}
